import { Action } from 'redux';
import { Identity } from '../../logic/domains/identity.domain';
import { EmulatedAdviser } from '../../logic/domains/emulatedAdviser.domain';

export enum AdviserDetailsActionTypes {
	ADVISER_TRY_GET_DETAILS = '@@adviser/TRY_GET_DETAILS',
	ADVISER_GET_DETAILS_SUCCESS = '@@adviser/GET_DETAILS_SUCCESS',
	ADVISER_GET_DETAILS_FAILURE = '@@adviser/GET_DETAILS_FAILURE',
	ADVISER_GET_DETAILS_LOADING = '@@adviser/ADVISER_GET_DETAILS_LOADING',
	ADVISER_GET_DETAILS_NOT_AUTHORISED = '@@adviser/ADVISER_GET_DETAILS_NOT_AUTHORISED',
}

export enum EmulationAdviserDetailsActionTypes {
	EMULATED_TRY_GET_OFFICE_USER_AND_ADVISER_DETAILS = '@@emulatedAdviser/TRY_GET_OFFICE_USER_AND_ADVISER_DETAILS',
	EMULATED_GET_OFFICE_USER_AND_ADVISER_DETAILS_SUCCESS = '@@emulatedAdviser/EMULATED_GET_OFFICE_USER_AND_ADVISER_DETAILS_SUCCESS',
}

export interface AdviserTryGetDetailsAction extends Action {
	readonly type: AdviserDetailsActionTypes.ADVISER_TRY_GET_DETAILS;
	adviserId: string | undefined;
}

export interface AdviserGetDetailsSuccessAction extends Action {
	readonly type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_SUCCESS;
	response?: Identity;
}

export interface AdviserGetDetailsFailureAction extends Action {
	readonly type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_FAILURE;
	message?: string;
}

export interface AdviserGetDetailsLoadingAction extends Action {
	readonly type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_LOADING;
	message?: string;
}

export interface AdviserGetDetailsIsAuthorisedAction extends Action {
	readonly type: AdviserDetailsActionTypes.ADVISER_GET_DETAILS_NOT_AUTHORISED;
	message?: string;
}

export interface EmulatedUserDetailsAction extends Action {
	readonly type: EmulationAdviserDetailsActionTypes.EMULATED_TRY_GET_OFFICE_USER_AND_ADVISER_DETAILS;
	emulationToken: string;
}

export interface EmulatedUserDetailsSuccessAction extends Action {
	readonly type: EmulationAdviserDetailsActionTypes.EMULATED_GET_OFFICE_USER_AND_ADVISER_DETAILS_SUCCESS;
	adviserDetails?: Identity;
	officeUserEmulatedAdviserDetails?: EmulatedAdviser;
	emulationToken?: String;
}

export type AdviserAction =
	| AdviserTryGetDetailsAction
	| AdviserGetDetailsLoadingAction
	| AdviserGetDetailsSuccessAction
	| AdviserGetDetailsFailureAction
	| EmulatedUserDetailsAction
	| EmulatedUserDetailsSuccessAction
	| AdviserGetDetailsFailureAction
	| AdviserGetDetailsIsAuthorisedAction;

export function adviserSetDetailsAction(
	adviserId: string | undefined
): AdviserTryGetDetailsAction {
	return {
		type: AdviserDetailsActionTypes.ADVISER_TRY_GET_DETAILS,
		adviserId,
	};
}

export function getEmulatedAdviserDetailsAction(
	emulationToken: string
): EmulatedUserDetailsAction {
	return {
		type:
			EmulationAdviserDetailsActionTypes.EMULATED_TRY_GET_OFFICE_USER_AND_ADVISER_DETAILS,
		emulationToken,
	};
}
